import Dispatcher from './Dispatcher'
import addListener from './addListener'
import { BlockEvent, Event, IEventPayload } from '../events/BlockEvent'

interface RemixEventContract {
    source: string
    event: Event
    payload: Object
}

export default class BlockListener {
    private readonly dispatcher: Dispatcher
    private readonly eventsMap: Map<Event, BlockEvent<IEventPayload>>
    private readonly targetOrigin: string
    private readonly source: string

    constructor(dispatcher: Dispatcher, targetOrigin: string, source: string, events: Array<BlockEvent<IEventPayload>>) {
        this.dispatcher = dispatcher
        this.targetOrigin = targetOrigin
        this.source = source
        this.eventsMap = new Map<string, BlockEvent<IEventPayload>>()
        for (let event of events)
            this.eventsMap.set(event.name, event)
    }

    listenBlocks = (window: Window): void => {
        // TODO add warning if couldn't add listener
        addListener(window, 'message', this.handleMessage as EventListener, false)
    }

    handleMessage = (message: MessageEvent): void =>  {
        if (!this.checkOrigin(message.origin))
            return

        let data = message.data as RemixEventContract
        let { source, event, payload } = data
        if (this.checkSource(source) && this.eventsMap.has(event)) {
            let eventBlock = this.eventsMap.get(event)
            if (eventBlock)
                this.dispatcher.dispatch(event, eventBlock.getPayload(payload));
        }
    }

    private checkOrigin = (origin: string): boolean => {
        return origin === this.targetOrigin
    }

    private checkSource = (source: string): boolean => {
        return source === this.source
    }
}